import { defineComponent as _defineComponent } from 'vue'
import {
  watchEffect,
  computed,
  ref,
  nextTick,
  defineProps,
  defineEmits,
  watch,
} from "../../../../adapter-vue";
import { handleSkeletonSize } from "../../utils/utils";
import Icon from "../../../common/Icon.vue";
import loading from "../../../../assets/icon/loading.gif";


export default /*#__PURE__*/_defineComponent({
  __name: 'message-video',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
  isPC: {
    type: Boolean,
    default: false,
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["uploading"],
  setup(__props, { emit: emits }) {

const props = __props




const data = ref();
const message = ref();
const show = ref(false);
const poster = ref("");
const posterWidth = ref(0);
const posterHeight = ref(0);
const skeleton = ref();
const video = ref();
const messageStatus = ref(props.messageItem.status);

const isWidth = computed(() => {
  const { snapshotWidth = 0, snapshotHeight = 0 } = message.value.payload;
  return snapshotWidth >= snapshotHeight;
});
const transparentPosterUrl =
  "https://web.sdk.qcloud.com/im/assets/images/transparent.png";

const toggleShow = () => {
  if (data.value.progress) {
    show.value = !show.value;
  }
};

// h5 部分浏览器（safari / wx）video标签 封面为空 在视频未上传完成前的封面展示需要单独进行处理截取
const getVideoBase64 = (url: string) => {
  return new Promise(function (resolve, reject) {
    let dataURL = "";
    let video = document.createElement("video");
    video.setAttribute("crossOrigin", "anonymous"); //处理跨域
    video.setAttribute("src", url);
    video.setAttribute("preload", "auto");
    video.addEventListener(
      "loadeddata",
      function () {
        let canvas = document.createElement("canvas"),
          width = video.videoWidth, //canvas的尺寸和图片一样
          height = video.videoHeight;
        canvas.width = width;
        canvas.height = height;
        (canvas as any).getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
        dataURL = canvas.toDataURL("image/jpeg"); //转换为base64
        posterWidth.value = width;
        posterHeight.value = height;
        resolve(dataURL);
      },
      { once: true }
    );
  });
};

const handlePosterUrl = async (data: any) => {
  if (!data) return "";
  if (messageStatus.value !== "success") {
    return await getVideoBase64(data.url);
  } else {
    return (
      (data.snapshotUrl !== transparentPosterUrl && data.snapshotUrl) ||
      (data?.message?.payload?.snapshotUrl !== transparentPosterUrl &&
        data?.message?.payload?.snapshotUrl) ||
      (data?.message?.payload?.thumbUrl !== transparentPosterUrl &&
        data?.message?.payload?.thumbUrl) ||
      (await getVideoBase64(data.url))
    );
  }
};

watchEffect(async () => {
  data.value = props.content;
  message.value = props.messageItem;
  if (!data.value) return;
  poster.value = await handlePosterUrl(data.value);
  nextTick(async () => {
    const containerWidth =
      document.getElementById("messageEle")?.clientWidth || 0;
    const max = !props.isPC ? Math.min(containerWidth - 172, 300) : 300;
    let size;
    if (messageStatus.value === "success") {
      let { snapshotWidth = 0, snapshotHeight = 0, snapshotUrl } = data.value;
      if (snapshotWidth === 0 || snapshotHeight === 0) return;
      if (snapshotUrl === transparentPosterUrl) {
        snapshotWidth = posterWidth.value;
        snapshotHeight = posterHeight.value;
      }
      size = handleSkeletonSize(snapshotWidth, snapshotHeight, max, max);
      skeleton?.value?.style &&
        (skeleton.value.style.width = `${size.width}px`);
      skeleton?.value?.style &&
        (skeleton.value.style.height = `${size.height}px`);
      if (props.isPC) {
        video?.value?.style && (video.value.style.width = `${size.width}px`);
        video?.value?.style && (video.value.style.height = `${size.height}px`);
      }
    } else {
      emits("uploading");
    }
  });
});

watch(
  () => props.messageItem.status,
  (newVal: any, oldVal: any) => {
    messageStatus.value = newVal;
    if (newVal === "success" && oldVal !== "success") {
      emits("uploading");
    }
  }
);

return { __sfc: true,props, emits, data, message, show, poster, posterWidth, posterHeight, skeleton, video, messageStatus, isWidth, transparentPosterUrl, toggleShow, getVideoBase64, handlePosterUrl, Icon, loading }
}

})